import { useState } from 'react'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { useAppConfig } from '~/hooks/useAppConfig.js'
import useScript, { SCRIPT_STATUS } from './useScript'

export function useAlipay() {
  const appConfig = useAppConfig()
  const isAlipay = appConfig.isAlipay
  const [alipay, setAlipay] = useState(null)
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const alipayScriptStatus = useScript(
    isAlipay
      ? `https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.inc.min.js`
      : ''
  )

  useEffect(() => {
    async function loadAlipay() {
      switch (alipayScriptStatus) {
        case SCRIPT_STATUS.READY: {
          try {
            setAlipay(alipay)
            setIsLoading(false)
          } catch (e) {
            Sentry.captureException(e)
            setError(e.message)
          }
          break
        }

        case SCRIPT_STATUS.ERROR: {
          setError('Alipay SDK failed to load')
          break
        }

        case SCRIPT_STATUS.IDLE:
        case SCRIPT_STATUS.LOADING:
        default: {
          setIsLoading(true)
          break
        }
      }
    }
    loadAlipay()
  }, [alipayScriptStatus])

  return {
    alipay,
    isAlipayLoading: isLoading,
    alipayError: error,
  }
}
